import { Form, Formik } from "formik";
import React from "react";
import { Button, InputGroup, Modal } from "react-bootstrap";
import { toast } from "react-toastify";
import * as yup from "yup";
import FormikTextField from "../../components/Forms/FormikTextField";
import LoaderButton from "../../components/LoaderButton";
import { Constants } from "../../libs/Constants";
import { update } from "../../libs/dbFunctions";
import { placeEvent } from "../../libs/eventsLib";
import { isUnAvailableRegion } from "./SetupComplete";
const MONTH_PER_YEAR = 12;
const initialValues = {
  ssn: "",
  salary: null,
  contributionPercentage: null,
};
const schema = yup.object({
  ssn: yup
    .number()
    .required("Last four digits of your SSN are required")
    .test(
      "len",
      "Must be exactly 4 characters",
      (val) => val && val.toString().length === 4
    ),
  salary: yup
    .number("Salary is required")
    .required("Salary is required")
    .moreThan(0, "Current Salary must be greater than 0")
    .nullable(),
  contributionPercentage: yup
    .number("Contribution percentage is required")
    .required("Contribution percentage is required")
    .moreThan(0, "Contribution percentage must be greater than 0")
    .max(100, "The Maximum Contribution Percentage can’t exceed 100%.")
    .nullable(),
});
const UploadBankAccountButton = ({ employee, onSuccess, plan }) => {
  const [open, setOpen] = React.useState(false);
  const [errorMessage, setErrorMessage] = React.useState("");

  const calculatePeriodsPerAnnum = () => {
    return MONTH_PER_YEAR / Number(plan.purchasePeriod);
  };

  const handleSubmit = async (values) => {
    let salary = Number(values.salary);
    let saveFields = {
      id: employee.id,
      salary,
      ssn: values.ssn,
      contributionAmount:
        (salary * values.contributionPercentage) /
        100 /
        calculatePeriodsPerAnnum(),
    };
    //update the userObj with salary and flags
    try {
      await update(Constants.dbTypes.USER, saveFields);
      await placeEvent(Constants.EVENT_TYPES.CONNECT_BANK, employee.email, {
        salary: values.salary,
        SSN: values.ssn,
        contributionPercentage: values.contributionPercentage,
      });
      onSuccess(saveFields);
    } catch (e) {
      if (e.response && e.response.data && e.response.data.error) {
        toast.error(e.response.data.error);
      } else {
        toast.error(e);
      }
    }
  };
  if (!plan) {
    return <>Loading...</>;
  }
  return (
    <>
      <Button
        onClick={() => setOpen(true)}
        disabled={isUnAvailableRegion(employee)}
      >
        Connect
      </Button>
      <Modal
        show={open}
        onHide={() => setOpen(false)}
        size="md"
        aria-labelledby="contained-modal-title-vcenter"
        centered
        className="contribution-modal font-secondary"
        backdrop="static"
      >
        <Modal.Header className="p-4" closeButton>
          <Modal.Title>Connect Bank</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Formik
            onSubmit={handleSubmit}
            initialValues={initialValues}
            validationSchema={schema}
            validateOnMount
          >
            {({ isValid, isSubmitting, values }) => (
              <Form className="w-100">
                <FormikTextField
                  size="lg"
                  controlId="ssn"
                  label="Last 4 of social"
                  name="ssn"
                  type="number"
                  className="mb-4"
                />
                <FormikTextField
                  size="lg"
                  controlId="salary"
                  label="Current Salary"
                  name="salary"
                  type="number"
                  className="mb-4"
                  inputGroupPrepend={
                    <InputGroup.Text id="basic-addon2">$</InputGroup.Text>
                  }
                  validateOnKeyChange={true}
                />
                <FormikTextField
                  size="lg"
                  controlId="contributionPercentage"
                  label="Contribution Percentage"
                  name="contributionPercentage"
                  type="number"
                  className="mb-4"
                  inputGroupPrepend={
                    <InputGroup.Text id="basic-addon2">%</InputGroup.Text>
                  }
                  onChange={(event, value) => {
                    setErrorMessage("");
                    if (
                      value &&
                      plan?.maxContribution?.percent &&
                      parseFloat(value) > plan?.maxContribution?.percent
                    ) {
                      setErrorMessage(
                        `Contribution Percentage should not exceed ${plan?.maxContribution?.percent}%.`
                      );
                    }
                  }}
                />
                {errorMessage && (
                  <div className="text-danger mb-2">{errorMessage}</div>
                )}
                <LoaderButton
                  block
                  type="submit"
                  variant="primary"
                  size="lg"
                  text="Next"
                  className="mb-2"
                  isLoading={isSubmitting}
                  disabled={!isValid || isSubmitting || errorMessage}
                >
                  Next
                </LoaderButton>
              </Form>
            )}
          </Formik>
        </Modal.Body>
      </Modal>
    </>
  );
};

export default UploadBankAccountButton;
